export function forX(count, fn) {
  return new Array(count).fill(null).map((v, i) => fn(i));
}
